<template>
  <div class="clinic-doctors-filter">
    <base-select
      v-model="filter.speciality"
      class="base-select"
      :placeholder="$t('Специальность', options)"
      empty-placeholder="----"
      :options="specialities"
      :filter-function="applySearchFilter"
    >
      <template #value="{ value }">
        {{ value.name }}
      </template>
      <template
        #item="{
          filteredOptions, highlightedIndex, value, select,
        }"
      >
        <li
          v-for="(option, i) in filteredOptions"
          :key="option.trasnlit"
          class="base-select__option"
          :class="{
            'is-active': i === highlightedIndex,
            'is-selected': value === option,
          }"
          @click="select(option)"
        >
          {{ option.name }}
        </li>
      </template>
    </base-select>
    <base-select
      v-model="filter.experience"
      class="base-select base-select_experience"
      :placeholder="$i18next.t('Стаж', options)"
      :options="experiences"
    >
      <template #value="{ value }">
        {{ $t(value.name, options) }}
      </template>
      <template
        #item="{
          filteredOptions, highlightedIndex, value, select,
        }"
      >
        <li
          v-for="(option, i) in filteredOptions"
          :key="option.name"
          class="base-select__option"
          :class="{
            'is-active': i === highlightedIndex,
            'is-selected': value === option,
          }"
          @click="select(option)"
        >
          {{ $t(option.name, options) }}
        </li>
      </template>
    </base-select>
    <gender-switch
      v-model="filter.gender"
      class="gender-switch"
      :options="genders"
    />
    <base-checkbox
      v-model="filter.isHomeCall"
      class="base-checkbox"
      :label="$t('Вызов на дом', options)"
    />
  </div>
</template>

<script>
import BaseSelect from 'www/vue_components/desktop/core/BaseSelect.vue'
import GenderSwitch from 'www/vue_components/desktop/core/GenderSwitch.vue'
import BaseCheckbox from 'www/vue_components/common/core/BaseCheckbox.vue'
import {
  pushHistoryState,
  scrollTo,
  isEmptyObject,
  getElementOffsetTop,
} from 'www/utils'

export default {
  components: {
    BaseCheckbox,
    BaseSelect,
    GenderSwitch,
  },
  props: {
    genders: {
      type: Array,
      default: () => ['M', 'F'],
    },
    specialitiesStringified: {
      type: String,
      default: '',
    },
    experiences: {
      type: Array,
      default: () => [
        { name: 'Любой', value: '' },
        { name: 'от 5 лет', value: '5' },
        { name: 'от 15 лет', value: '15' },
      ],
    },
    specialtiesWithAges: {
      type: Object,
      default: () => ({}),
    },
    lpuDoctorsUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      specialities: null,
      filter: {
        speciality: '',
        experience: '',
        gender: '',
        isHomeCall: false,
      },
      options: { ns: this.$i18next.language },
    }
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.handleFilterChange()
      },
    },
  },
  created() {
    this.specialities = JSON.parse(this.specialitiesStringified)

    const hashObj = this.parseHash()

    if (hashObj.speciality) {
      this.filter.speciality = this.specialities.find(spec => spec.id === +hashObj.speciality)

      $('.b-doctor-card').each((_, item) => {
        this.changeWpAgeRange($(item))
      })
    }

    if (hashObj.gender) {
      this.filter.gender = hashObj.gender
    }

    if (hashObj.staj) {
      this.filter.experience = this.experiences.find(exp => exp.value === hashObj.staj)
    }

    if (hashObj.na_dom) {
      this.filter.isHomeCall = true
    }
  },
  mounted() {
    $('.b-empty-doctors_js').click(this.clearFilter)
    $('body').on('filter:clear', this.clearFilter)
  },
  methods: {
    applySearchFilter(search, options) {
      return options.filter(({ name }) => name.toLowerCase().includes(search.toLowerCase()))
    },
    handleFilterChange() {
      const vm = this
      const selector = []

      if (this.filter.gender) {
        selector.push(`[data-gender="${this.filter.gender}"]`)
      }

      if (this.filter.speciality && this.filter.speciality.id) {
        selector.push(`[data-spec*="${this.filter.speciality.id}"]`)
      }

      if (this.filter.experience && this.filter.experience.value) {
        selector.push(`[data-experience"${this.filter.experience.value}"]`)
      }

      const activeFilters = this.getActiveFilters()

      // eslint-disable-next-line func-names
      $('.b-doctor-card').each(function () {
        const spec = $(this).data('spec')
        const gender = $(this).data('gender')
        const experience = $(this).data('experience')
        const naDom = $(this).data('na-dom')

        $(this).removeClass('filtered')
        $(this).addClass('hidden')

        const attributesMatch = activeFilters.filter(key => {
          if (key === 'experience') {
            return experience >= vm.filter.experience.value
          }

          if (key === 'gender') {
            return vm.filter.gender === gender
          }

          if (key === 'speciality') {
            return spec.includes(vm.filter.speciality.id)
          }

          if (key === 'isHomeCall') {
            return !!naDom
          }

          return null
        })

        if (activeFilters.length < 1) {
          $(this).removeClass('hidden')
          return
        }

        if (activeFilters.length === attributesMatch.length) {
          $(this).addClass('filtered')

          vm.changeWpAgeRange($(this))

          if (vm.filter.speciality && vm.filter.speciality.id) {
            $('[data-filtered-spec]').data('filtered-spec', vm.filter.speciality.id)
          }
        }
      })

      try {
        if (!activeFilters.includes('speciality')) {
          this.resetWpAgeRange()
        }
      } catch { /* Empty */ }

      if (activeFilters.length < 1) {
        document.dispatchEvent(new Event('clinic-filter:unfilter'))
      } else {
        document.dispatchEvent(new Event('clinic-filter:filter'))
      }

      pushHistoryState(this.generateUrl(), this.filter)
      scrollTo(getElementOffsetTop(document.querySelector('#tab-content')), { duration: 1000, offset: 0 })
    },
    parseHash() {
      const hashObj = {}

      window.location.hash.slice(1).split('&').forEach(keyVal => {
        const [key, value] = keyVal.split('=')

        hashObj[key] = value
      })

      return hashObj
    },
    getActiveFilters() {
      return Object.keys(this.filter).filter(key => {
        if (typeof this.filter[key] === 'object') {
          return this.filter[key].value
        }

        return this.filter[key]
      })
    },
    generateUrl() {
      const query = []

      if (this.filter.speciality && this.filter.speciality.id) {
        query.push(`speciality=${this.filter.speciality.id}`)
      }

      if (this.filter.experience && this.filter.experience.value) {
        query.push(`staj=${this.filter.experience.value}`)
      }

      if (this.filter.gender) {
        query.push(`gender=${this.filter.gender}`)
      }

      if (this.filter.isHomeCall) {
        query.push('na_dom=true')
      }

      if (query.length) {
        return `#${query.join('&')}`
      }

      return './'
    },
    clearFilter() {
      Object.keys(this.filter).forEach(key => {
        const value = this.filter[key]

        if (typeof value === 'boolean') {
          this.filter[key] = false
          return
        }

        this.filter[key] = ''
      })
    },
    changeWpAgeRange($doctorCard) {
      try {
        if (isEmptyObject(this.specialtiesWithAges)) {
          return
        }

        const $wpAgeRangeEl = $doctorCard.find('[data-qa="doctor_workplace_age_limit_text"]')
        const $wpAgeRangeWrapperEl = $doctorCard.find('[data-qa="doctor_workplace_age_range_wrapper"]')
        const doctorId = $doctorCard.attr('data-doctor-id')
        const data = this.specialtiesWithAges[doctorId].find(({ id }) => (
          Number(id) === Number(this.filter.speciality.id)))

        if (!data) {
          return
        }

        if (data.ageRangeText) {
          $wpAgeRangeEl.text(data.ageRangeText)
          $wpAgeRangeWrapperEl.removeClass('d-none')
        }
      } catch { /* Empty */ }
    },
    resetWpAgeRange() {
      try {
        if (isEmptyObject(this.specialtiesWithAges)) {
          return
        }

        $('.b-doctor-card').each((_, item) => {
          $(item).find('[data-qa="doctor_workplace_age_range_wrapper"]').addClass('d-none')
        })
      } catch { /* Empty */ }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.clinic-doctors-filter {
  display: flex;
  justify-content: space-between;
  height: 80px;
  padding: 16px;
  box-shadow: 0 15px 20px rgba(151, 158, 167, 0.1);
  border-radius: 5px 5px 0 0;
  box-sizing: border-box;
  background-color: $ui-kit-bg-gray-0;
  position: relative;
}

.base-select {
  margin-right: 16px;
  flex-grow: 1;
  max-width: 100%;
}

.base-select_experience {
  max-width: 183px;
}

.base-checkbox {
  height: 48px;
  background: $color-ultra-deep-grey;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
}

.gender-switch {
  margin-right: 16px;
}
</style>
